import type { CroppedImage, GridElement } from '@omnia/ui/src/lib'
import { CmsImage, CmsLinkComponent } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import type { BannerImagePropsApi } from './models'

export const BannerImage: FC<GridElement<BannerImagePropsApi>> = ({ value }) => {
    const { desktop, mobile, link } = value

    const image: CroppedImage = {
        ...mobile,
        ...desktop,
    }

    return (
        <CmsLinkComponent link={link} className="banner-image">
            <CmsImage image={image} />
        </CmsLinkComponent>
    )
}
